import { useRef } from "react";
import QRCode from "react-qr-code";
import "./QrCodePage.css";
import { useAuth } from "../../../hooks/useAuth";

const DOWNLOAD_SCALE = 8;
const QR_SIZE = 220;
const QR_PADDING = 16;

const QrCodePage = () => {
  const { user } = useAuth();
  const cardRef = useRef<HTMLDivElement>(null);

  const slug = user?.activeOrganization?.slug ?? "";
  const websiteUrl = slug ? `${window.location.origin}/${slug}` : "";

  const handleDownload = () => {
    const svg = cardRef.current?.querySelector("svg");
    if (!svg) return;

    const svgBlob = new Blob(
      [new XMLSerializer().serializeToString(svg)],
      { type: "image/svg+xml;charset=utf-8" },
    );
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();

    img.onload = () => {
      const size = QR_SIZE * DOWNLOAD_SCALE;
      const pad = QR_PADDING * DOWNLOAD_SCALE;
      const canvas = document.createElement("canvas");
      canvas.width = size + pad * 2;
      canvas.height = size + pad * 2;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, pad, pad, size, size);
      URL.revokeObjectURL(url);

      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `${slug || "organization"}-website-qr.png`;
      link.click();
    };

    img.src = url;
  };

  if (!websiteUrl) {
    return (
      <div className="qr-page">
        <div className="qr-empty">
          <p>No active organization website to show a QR code for.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="qr-page">
      <div className="qr-header">
        <div>
          <h2>Website QR Code</h2>
          <p>Scan to open your organization's public website.</p>
        </div>
      </div>

      <div className="qr-card">
        <div ref={cardRef} className="qr-card__qr" aria-label={`QR code for ${websiteUrl}`}>
          <QRCode value={websiteUrl} size={QR_SIZE} />
        </div>
        <p className="qr-card__url">{websiteUrl}</p>
        <button
          type="button"
          className="qr-card__btn"
          onClick={handleDownload}
        >
          Save as image
        </button>
      </div>
    </div>
  );
};

export default QrCodePage;